import React from 'react';
import { Card, Typography, List, Space, Alert, Tag } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy = () => {
  const privacyItems = [
    {
      title: 'Collecte des données',
      content: 'Nous collectons certaines informations personnelles vous concernant lorsque vous vous inscrivez sur notre site web, vous abonnez à nos cours, complétez des formulaires ou interagissez avec nos services. Ces informations peuvent inclure votre nom, adresse e-mail, informations de paiement, historique de navigation et autres informations que vous choisissez de nous fournir.'
    },
    {
      title: 'Utilisation des données',
      content: 'Les données que nous collectons sont utilisées pour vous fournir nos services éducatifs, améliorer notre plateforme, personnaliser votre expérience, traiter vos paiements, répondre à vos demandes et communiquer avec vous concernant nos cours et offres spéciales.'
    },
    {
      title: 'Protection des données',
      content: 'Nous prenons des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, altération, divulgation ou destruction. Vos informations sont stockées sur des serveurs sécurisés et ne sont accessibles qu\'aux membres autorisés de notre équipe.'
    },
    {
      title: 'Partage des données',
      content: 'Nous ne vendons, ne louons ni ne partageons vos données personnelles avec des tiers à des fins commerciales. Cependant, nous pouvons partager vos informations avec des prestataires de services tiers qui nous aident à exploiter notre site web et à fournir nos services (par exemple, traitement des paiements et support technique), mais ils sont tenus de protéger vos données conformément à cette politique de confidentialité.'
    },
    {
      title: 'Cookies et technologies similaires',
      content: (
        <span>
          Nous utilisons des cookies et des technologies similaires pour améliorer votre expérience de navigation sur notre site web. Les cookies sont de petits fichiers texte stockés sur votre appareil lorsque vous visitez notre site. Vous pouvez gérer vos préférences en matière de cookies en ajustant les paramètres de votre navigateur. Pour plus d'informations, consultez notre{' '}
          <Link to="/cookie-policy" style={{ color: '#1890ff', fontWeight: 'bold' }}>
            politique en matière de cookies
          </Link>.
        </span>
      )
    },
    {
      title: 'Mineurs',
      content: 'Notre plateforme s\'adresse aux personnes âgées de plus de 18 ans. Nous ne collectons pas intentionnellement d\'informations personnelles auprès des mineurs. Si nous prenons connaissance de données personnelles de mineurs, nous prendrons les mesures nécessaires pour les supprimer de nos systèmes.'
    },
    {
      title: 'Droits des utilisateurs',
      content: 'Vous avez le droit d\'accéder à vos données personnelles, de les corriger, de les mettre à jour ou de les supprimer. Vous pouvez également demander à ne plus recevoir nos communications marketing. Pour exercer ces droits ou poser des questions concernant vos données, veuillez nous contacter à contact@nomidya.com.'
    },
    {
      title: 'Modifications de la politique de confidentialité',
      content: 'Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Les modifications prendront effet dès leur publication sur notre site web. Il est de votre responsabilité de consulter régulièrement cette page pour prendre connaissance des éventuelles mises à jour.'
    }
  ];

  const userRights = [
    'Accéder à vos données personnelles',
    'Corriger vos données personnelles',
    'Mettre à jour vos données personnelles', 
    'Supprimer vos données personnelles',
    'Ne plus recevoir nos communications marketing'
  ];

  return (
    <div className="privacy-policy-page" style={{ padding: '20px 0' }}>
      <div className="container">
        <Card className="mb-4" style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          {/* En-tête */}
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <Title level={1} style={{ color: '#1890ff' }}>
              Politique de Confidentialité
            </Title>
            <Paragraph style={{ fontSize: '16px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
              Chez Nomidya, nous prenons la protection de vos données personnelles très au sérieux. Cette politique de confidentialité a pour objectif de vous informer sur la manière dont nous collectons, utilisons, partageons et protégeons vos données.
            </Paragraph>
          </div>

          {/* Message d'acceptation */}
          <Alert
            message="Acceptation de la politique"
            description="En utilisant notre plateforme, vous acceptez les conditions de cette politique de confidentialité."
            type="info"
            showIcon
            style={{ marginBottom: '30px' }}
          />

          {/* Contenu de la politique */}
          <List
            itemLayout="vertical"
            size="large"
            dataSource={privacyItems}
            renderItem={(item, index) => (
              <List.Item key={index}>
                <Card 
                  hoverable
                  style={{ 
                    borderLeft: `4px solid #1890ff`,
                    marginBottom: '16px'
                  }}
                >
                  <Space direction="vertical" size="small" style={{ width: '100%' }}>
                    <Title level={4} style={{ margin: 0, color: '#1890ff' }}>
                      {item.title}
                    </Title>
                    <Paragraph style={{ 
                      fontSize: '15px', 
                      lineHeight: '1.6', 
                      margin: 0,
                      textAlign: 'justify'
                    }}>
                      {item.content}
                    </Paragraph>
                  </Space>
                </Card>
              </List.Item>
            )}
          />

          {/* Section droits des utilisateurs - mise en évidence */}
          <Card style={{ 
            marginTop: '30px',
            background: '#f0f2f5',
            border: '2px solid #52c41a'
          }}>
            <Title level={3} style={{ color: '#52c41a', textAlign: 'center' }}>
              Vos Droits en un Coup d'Œil
            </Title>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '8px' }}>
              {userRights.map((right, index) => (
                <Tag key={index} color="green" style={{ fontSize: '14px', padding: '4px 12px' }}>
                  {right}
                </Tag>
              ))}
            </div>
          </Card>

          {/* Message d'engagement */}
          <Card style={{ 
            marginTop: '30px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            textAlign: 'center'
          }}>
            <Title level={3} style={{ color: 'white', marginBottom: '16px' }}>
              Notre Engagement
            </Title>
            <Paragraph style={{ 
              fontSize: '16px', 
              lineHeight: '1.7', 
              color: 'white',
              marginBottom: '16px'
            }}>
              Nous sommes déterminés à protéger vos données personnelles et à respecter votre vie privée. Nous vous remercions de votre confiance en choisissant Nomidya pour votre parcours d'apprentissage.
            </Paragraph>
          </Card>

          {/* Contact pour questions */}
          <Card style={{ 
            marginTop: '20px', 
            background: '#fff7e6',
            border: '1px solid #faad14',
            textAlign: 'center'
          }}>
            <Title level={4} style={{ color: '#faad14', marginBottom: '8px' }}>
              Questions sur cette Politique ?
            </Title>
            <Text style={{ fontSize: '15px' }}>
              Si vous avez des questions concernant notre politique de confidentialité, n'hésitez pas à nous contacter à{' '}
              <Text strong style={{ color: '#1890ff' }}>contact@nomidya.com</Text>
            </Text>
          </Card>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicy;